module.exports = __webpack_public_path__ + "img/default-flow.212147b4.svg";